module.exports = __webpack_public_path__ + "img/UpTriangleRed.36d5de8b.png";